import { render, staticRenderFns } from "./FormularioResponsavel.vue?vue&type=template&id=720bb306&"
import script from "./FormularioResponsavel.vue?vue&type=script&lang=ts&"
export * from "./FormularioResponsavel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports